import React, { useState } from 'react'
import { Box, Button, Card, CardHeader, Divider } from '@mui/material'
import { PropertyList } from '../../../../../components/PropertyList'
import { PropertyListItem } from '../../../../../components/PropertyListItem'
import CircularLoading from '../../../../../components/CircularProgress'
import {
  EOrderStatus,
  IOrder,
  OrderRecipient,
} from '../../../../../types/order'
import { OrderAddressFormModal } from './OrderAddressFormModal'
import EditIcon from '@mui/icons-material/Edit'

interface FilterGroupProps {
  isLoading: boolean
  data?: OrderRecipient | any
  order: IOrder
  onUpdateAddressListSuccess: () => void
}

const OrderRecipientDetailCard = ({
  isLoading,
  data,
  order,
  onUpdateAddressListSuccess,
}: FilterGroupProps) => {
  const [isModalEditRecipient, setIsModalEditRecipient] =
    useState<boolean>(false)
  const editable = ![EOrderStatus.CANCLELLED].includes(
    order?.status as EOrderStatus,
  )
  return (
    <>
      <OrderAddressFormModal
        isOpen={isModalEditRecipient}
        onClose={setIsModalEditRecipient}
        order={order}
        onUpdateAddressListSuccess={onUpdateAddressListSuccess}
      />
      <CircularLoading isLoading={isLoading} />
      <Card>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: 2,
          }}
        >
          <CardHeader title="รายละเอียดผู้รับ" />
          {editable && (
            <Button
              startIcon={<EditIcon />}
              color="warning"
              size="medium"
              variant="text"
              onClick={() => setIsModalEditRecipient(!isModalEditRecipient)}
            >
              แก้ไขรายละเอียดผู้รับ
            </Button>
          )}
        </Box>
        <Divider />
        <PropertyList>
          <PropertyListItem
            align={`horizontal`}
            label="ชื่อ-นามสกุล"
            value={data?.name}
          />
          <Divider />
          <PropertyListItem
            align={`horizontal`}
            label="ที่อยู่"
            value={data?.address}
          />
          <Divider />
          <PropertyListItem
            align={`horizontal`}
            label="อำเภอ"
            value={data?.district}
          />
          <Divider />
          <PropertyListItem
            align={`horizontal`}
            label="ตำบล"
            value={data?.subDistrict}
          />
          <Divider />
          <PropertyListItem
            align={`horizontal`}
            label="จังหวัด"
            value={data?.province}
          />
          <Divider />
          <PropertyListItem
            align={`horizontal`}
            label="รหัสไปรษณีย์"
            value={data?.zipcode}
          />
          <Divider />
          <PropertyListItem
            align={`horizontal`}
            label="หมายเลขโทรศัพท์"
            value={data?.phone}
          />
          <Divider />
          <PropertyListItem
            align={`horizontal`}
            label="อีเมล์"
            value={data?.email ? data?.email : <em>ไม่ระบุ</em>}
          />
          <Divider />
          <PropertyListItem
            align={`horizontal`}
            label="ช่องทางการติดต่อ"
            value={data?.social ? data?.social : <em>ไม่ระบุ</em>}
          />
          <Divider />
          <PropertyListItem
            align={`horizontal`}
            label="เลขประจำตัวผู้เสียภาษี"
            value={data?.crn ? data?.crn : <em>ไม่ระบุ</em>}
          />
          <Divider />
          <PropertyListItem
            align={`horizontal`}
            label="หมายเลขใบเสร็จรับเงิน"
            value={order?.referrer?.refId ?? <em>ไม่ระบุ</em>}
          />
          <Divider />
        </PropertyList>
      </Card>
    </>
  )
}

export default OrderRecipientDetailCard
